import { ICanvas, INodeState } from "../typing";
/**
 * 计算画布节点的fix偏差值
 * @param canvas
 */
export const pageDataFixTransform = (canvas: ICanvas[]) => {
  canvas.map((item) => {
    const { nodes } = item.nodes;
    nodeFixTransform(nodes, 1334);
  });
};

/**
 * 计算节点的fix偏差值
 * @param nodes
 * @param canvasHeight
 */
export const nodeFixTransform = (nodes: INodeState[], canvasHeight = 1334) => {
  nodes = nodes.map((node) => {
    let fixValue = 0;
    if (node.fixType) {
      // 相对顶部固定
      if (node.fixType === 1) {
        fixValue = node.top;
      } else if (node.fixType === 2) {
        // 相对底部固定
        fixValue = canvasHeight - node.top - node.height;
      }
      node.fixValue = fixValue;
    }

    if (node?.children?.length) {
      nodeFixTransform(node.children, canvasHeight);
    }
    return node;
  });
};
